import PlanvasBaseApi from './api';
import { Field as IField } from '../API';

export interface UpdateFieldInput {
  name?: string;
  label?: string;
  type?: string;
  dataSource?: string;
  dataSourceType?: string;
  required?: boolean;
  options?: string[];
}

export interface GetFieldsResponse {
  items: IField[];
  nextToken?: string;
}

export default class FieldsApi extends PlanvasBaseApi {
  /**
   * Get all fields for a form
   * @param formId - The ID of the form
   * @param nextToken - Optional pagination token
   * @returns List of fields
   */
  async getFields(formId: string, nextToken?: string): Promise<GetFieldsResponse> {
    return this.get('/fields', { formId, nextToken });
  }

  /**
   * Update a field
   * @param id - The ID of the field to update
   * @param input - The update input
   * @param organizationId - The organization ID
   * @returns The updated field
   */
  async updateField(id: string, input: UpdateFieldInput, organizationId: string): Promise<IField> {
    return this.put(`/processmodule/${organizationId}/field/${id}`, input);
  }

  /**
   * Delete a field
   * @param id - The ID of the field to delete
   * @param organizationId - The organization ID
   * @returns The deleted field
   */
  async deleteField(id: string, organizationId: string): Promise<IField> {
    return this.delete(`/processmodule/${organizationId}/field/${id}`);
  }

  /**
   * Create a new field
   * @param input - The field creation input
   * @param organizationId - The organization ID
   * @returns The created field
   */
  async createField(input: Omit<IField, 'id'>, organizationId: string): Promise<IField> {
    return this.post(`/processmodule/${organizationId}/field`, input);
  }

  /**
   * Get a single field by ID
   * @param id - The ID of the field
   * @param organizationId - The organization ID
   * @returns The field
   */
  async getField(id: string, organizationId: string): Promise<IField> {
    return this.get(`/processmodule/${organizationId}/field/${id}`);
  }
}
